import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Radio, message, Alert } from 'hljd'
import ExtensionDuration from './extensionDuration'
import Upload from '../ReportForm/LiveInfo/Upload'
import { getDateFormat } from '@hlj/hlj-utils'
import { observer } from 'mobx-react'
import Style from './style.module.less'
import cls from 'classnames'
import getVal from 'lodash/get'

const FormItem = Form.Item
const RadioGroup = Radio.Group
const RadioButton = Radio.Button

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}

@observer
export default class extends Component {
  getStartTime = () => {
    const {
      form: { getFieldValue }
    } = this.props
    const datePicker = getFieldValue('datePicker')
    if (datePicker) {
      return `${getDateFormat(getFieldValue('datePicker'), 'YYYY-MM-DD HH:mm')}`
    } else {
      return ''
    }
  }

  checkSpreadTime = start_time => e => {
    if (!start_time) {
      message.info('请先选择直播时间')
      return ''
    } else {
      return e.target.value
    }
  }

  computePrice = (liveType, time, price) => {
    const {
      liveInfo: { popTime }
    } = this.props
    const spreaded = popTime && +popTime
    //console.log(show_spread, liveType)
    if (!spreaded) {
      return (
        ((time - 45) / 15) * parseInt(price[liveType].unitPrice) +
        parseInt(price[liveType].basePrice)
      )
    } else {
      return (time / 15) * parseInt(price[liveType].unitPrice)
    }
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue },
      type, //edit 编辑场景 modal 弹窗场景
      liveInfo = {},
      fromType
    } = this.props

    const price = {
      1: getVal(liveInfo, 'countryPrice', {}),
      2: getVal(liveInfo, 'nativePrice', {})
    }

    const show_spread = getFieldValue('fromType') === 1 || type === 'modal' //是否展示推广选项
    const time = getFieldValue('popTime') || 0
    const liveType = getFieldValue('liveType') || +liveInfo.liveType || 1
    const start_time = this.getStartTime()
    const is_spread = liveInfo.popTime && +liveInfo.popTime // 是否已经设置了推广

    return (
      <div className={Style.spread}>
        {is_spread ? (
          <Alert
            style={{ marginBottom: 20, color: '#FF801A' }}
            message={`本场直播已经设置${liveInfo.popTime}分钟推广时长`}
            type="warning"
            showIcon
          />
        ) : (
          ''
        )}
        {type === 'edit' ? (
          <FormItem label={'推广'} {...formItemLayout}>
            {getFieldDecorator('fromType', {
              initialValue: '',
              getValueFromEvent: this.checkSpreadTime(start_time),
              rules: [
                {
                  required: start_time ? true : false,
                  message: '请选择是否推广'
                }
              ]
            })(
              <RadioGroup>
                <Radio value={1}>推广直播</Radio>
                <Radio value={2}>不推广直播</Radio>
              </RadioGroup>
            )}
          </FormItem>
        ) : +liveInfo.popTime ? (
          ''
        ) : (
          <FormItem
            label={'推广图'}
            {...formItemLayout}
            extra={
              <div style={{ marginTop: -8 }}>
                推广图在直播开始后有机会被抓取到资源位。
              </div>
            }
          >
            <div>
              {getFieldDecorator('extensionBanner', {
                initialValue: ''
              })(<Upload limitSize={{ width: 1080, height: 432 }} isBanner />)}
            </div>
          </FormItem>
        )}
        <div
          className={cls({
            [Style.animate]: true,
            [Style.hide]: show_spread ? false : true
          })}
        >
          <div className={Style['radio-group']}>
            {type === 'modal' && +fromType === 1 ? (
              <FormItem label={'推广范围'} {...formItemLayout}>
                <div className={Style.tag}>
                  {+liveType === 1 ? '全国' : '本地及周边'}
                </div>
              </FormItem>
            ) : (
              <FormItem label={'推广范围'} {...formItemLayout}>
                {getFieldDecorator('liveType', {
                  initialValue: 1,
                  rules: [
                    {
                      required: true,
                      message: '请选择推广范围'
                    }
                  ]
                })(
                  <RadioGroup>
                    <RadioButton value={1}>全国</RadioButton>
                    <RadioButton value={2}>本地及周边</RadioButton>
                  </RadioGroup>
                )}
              </FormItem>
            )}
          </div>
          <FormItem label={'推广时长'} {...formItemLayout}>
            {getFieldDecorator('popTime', {
              initialValue: +liveInfo.popTime ? 15 : 45
            })(
              <ExtensionDuration
                min={+liveInfo.popTime ? 15 : 45}
                description={
                  +liveInfo.popTime
                    ? '在原基础上增加时长，设置之后不支持减少'
                    : '为保证推广效果，最少推广45分钟，设置之后不支持减少'
                }
              />
            )}
          </FormItem>
          <FormItem
            label={'总价'}
            {...formItemLayout}
            extra={
              is_spread ? (
                ''
              ) : (
                <div>
                  <div>
                    注：直播开始时间和推广时长不同，推广收费不同，推广设置后<span
                      style={{ color: '#448AFC' }}
                    >
                      只支持增加推广时长不支持减少。
                    </span>直播时间到了后就开始推广本场直播，<span
                      style={{ color: '#448AFC' }}
                    >
                      请按时开播。
                    </span>
                  </div>
                </div>
              )
            }
          >
            <span className={Style.price}>{`￥${this.computePrice(
              liveType,
              time,
              price
            )}`}</span>
          </FormItem>
        </div>
      </div>
    )
  }
}
